const antdTheme = {
  token: {
    colorPrimary: '#6B35D4',
    colorPrimaryHover: '#8B55F4',
    colorPrimaryActive: '#5020B0',
    colorBgBase: '#ffffff',
    colorTextBase: '#1a1a2e',
    colorLink: '#6B35D4',
    borderRadius: 10,
    borderRadiusLG: 14,
    borderRadiusSM: 6,
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: 15,
    fontSizeLG: 16,
    fontSizeXL: 20,
    fontSizeHeading1: 48,
    fontSizeHeading2: 36,
    fontSizeHeading3: 28,
    fontSizeHeading4: 22,
    fontSizeHeading5: 18,
    colorSuccess: '#12B76A',
    colorError: '#F04438',
    colorWarning: '#F79009',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    boxShadowSecondary: '0 8px 32px rgba(107,53,212,0.15)',
  },
  components: {
    Button: {
      primaryColor: '#ffffff',
      primaryShadow: '0 4px 16px rgba(107, 53, 212, 0.35)',
      borderRadius: 10,
      fontWeight: 600,
    },
    Input: {
      borderRadius: 10,
    },
    Modal: {
      borderRadiusLG: 16,
    },
    Steps: {
      colorPrimary: '#6B35D4',
    },
    Tabs: {
      inkBarColor: '#6B35D4',
      itemSelectedColor: '#6B35D4',
      itemHoverColor: '#8B55F4',
    },
    Collapse: {
      borderRadius: 12,
    },
  },
};

export default antdTheme;
